<script>
	import { setContext, onMount } from "svelte";
	import { connected, user, token, alerts, city, isConnectedVar } from "./store"

	import Head from "./components/head.svelte";

	/* Routes */
	import { Router, Route } from "svelte-routing";
	
	import Home from "./routes/Home.svelte";
	import NotFound from "./routes/NotFound.svelte";
	import VerifForgotPassword from "./routes/VerifForgotPassword.svelte";
	import VerifEmail from "./routes/VerifEmail.svelte";

	import Profile from "./routes/Profile.svelte";
	import Params from "./routes/Params.svelte";
	import Logout from "./routes/Logout.svelte";
	/* End of Routes */

	/* Locales / Translations */
	import { addMessages, init as i18n_init, getLocaleFromNavigator } from 'svelte-i18n';
	import fr from "./locales/fr-fr.json";
	import en from "./locales/en-us.json";

	addMessages("fr", fr);
	addMessages("fr-FR", fr);

	addMessages("en", en);
	addMessages("en-US", en);

	i18n_init({
		fallbackLocale: 'fr',
		initialLocale: getLocaleFromNavigator(),
	});
	/* End of Locales / Translations */
	
	import axios from "axios";

	export let url = "";

	let apiUrl;
	let hostname = location.host;

	if (!isProduction){
		apiUrl                = "http://oxalt.test/api/";
	} else {
		if(hostname == "oxalt.test"){
			apiUrl               = "http://oxalt.test/api/";
		} else {
			apiUrl               = "https://oxalt.fr/api/";
		}
	}

	setContext("apiUrl", apiUrl);
	setContext("hostname", hostname);

	async function isConnected(){
		let checkConnected;

		await axios.get(apiUrl + "checkConnected.php?lang=" + getLocaleFromNavigator())
		.then(function (response){
			checkConnected = response.data;
		});

		$connected = checkConnected.connected;
		$city = checkConnected.city;
		
		if($connected === true){
			$user   = checkConnected.user;
			$token  = checkConnected.token;
			$alerts = checkConnected.alerts;
		}
	}
	
	onMount(() => {
		$isConnectedVar = isConnected();
    });
</script>

{#await $isConnectedVar}
	<Head />
{:then}
	{#if !$connected}
		<Head welcome="true"/>
	{:else}
		<Head />
	{/if}

	<Router url="{url}">
		<Route path="/"><Home /></Route>

		{#key $connected}
			{#if !$connected}
				<Route path="verifForgotPassword/:token/" component="{VerifForgotPassword}" />
			{/if}

			{#if $connected}
				<Route path="profile" component="{Profile}" />
				<Route path="profile/:id/:name/" component="{Profile}" />

				<Route path="params" component="{Params}" />

				<Route path="Logout/:token" component="{Logout}" />
			{/if}
		{/key}

		<Route path="verifEmail/:id/:token/" component="{VerifEmail}" />

		<Route component={NotFound} />
		<Route path="404" component={NotFound} />
	</Router>
{/await}